// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"eaf744a2","237":"b7ba2996","365":"3a6b74c6","488":"29b71886","511":"db4216c2","658":"9e39c72d"}[chunkId] + ".chunk.js";
};